import { EventEmitter } from "@angular/core";
import { Directive, ElementRef, Output } from "@angular/core";

@Directive({
  selector: '[legend-stats]'
})
export class LegendStatsDirective {
  @Output() sizeChange: EventEmitter<void> = new EventEmitter<void>();

  private domElement: HTMLElement;

  observer: ResizeObserver;

  constructor(private elementRef: ElementRef) {
    this.domElement = this.elementRef.nativeElement as HTMLElement;

    this.observer = new ResizeObserver(entries => {
      this.sizeChange.emit();
    });
    this.observer.observe(this.domElement);
  }

  ngOnDestroy() {
    this.observer.disconnect();
  }
}
